<template>
  <div class="bar-chart">
    <div
      v-for="(item, i) in data"
      :key="i"
      class="bar-row"
      :class="{ 'bar-row--clickable': clickable }"
      @click="$emit('select', item)"
    >
      <div class="bar-label" :title="item.label">{{ item.label }}</div>
      <div class="bar-track">
        <div
          class="bar-fill"
          :style="{ width: pct(item.value) + '%', background: item.color || color }"
        ></div>
      </div>
      <div class="bar-value">{{ formatValue(item.value) }}</div>
    </div>
    <div v-if="data.length === 0" class="bar-empty">No data to display</div>
  </div>
</template>

<script>
export default {
  name: "BarChart",
  props: {
    // data: [{ label, value, color? }]
    data: { type: Array, default: () => [] },
    color: { type: String, default: "#1565C0" },
    max: { type: Number, default: null },
    suffix: { type: String, default: "" },
    clickable: { type: Boolean, default: false },
  },
  computed: {
    computedMax() {
      if (this.max !== null) return this.max;
      const vals = this.data.map((d) => d.value || 0);
      return Math.max(1, ...vals);
    },
  },
  methods: {
    pct(value) {
      return Math.round(((value || 0) / this.computedMax) * 100);
    },
    formatValue(value) {
      return `${Math.round(value || 0)}${this.suffix}`;
    },
  },
};
</script>

<style scoped>
.bar-chart {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bar-row {
  display: grid;
  grid-template-columns: 140px 1fr 48px;
  align-items: center;
  gap: 12px;
}

.bar-row--clickable {
  cursor: pointer;
  border-radius: 8px;
  padding: 2px 4px;
  margin: -2px -4px;
  transition: background 0.2s;
}

.bar-row--clickable:hover {
  background: rgba(21, 101, 192, 0.06);
}

.bar-label {
  font-size: 0.875rem;
  color: #455A64;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bar-track {
  height: 10px;
  background: #ECEFF1;
  border-radius: 6px;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  border-radius: 6px;
  transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 2px;
}

.bar-value {
  font-size: 0.8rem;
  font-weight: 600;
  color: #607D8B;
  text-align: right;
}

.bar-empty {
  color: #B0BEC5;
  font-size: 0.875rem;
  text-align: center;
  padding: 24px;
}

@media (max-width: 600px) {
  .bar-row {
    grid-template-columns: 90px 1fr 40px;
    gap: 8px;
  }
}
</style>
